
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Dropdown, Tab } from 'react-bootstrap';
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { KTIcon } from '../../../_metronic/helpers';
import Select, { StylesConfig } from 'react-select';
import { GetDataForExpenseSheetPrintAsync, updateMasterExpenseSheetId, resetSelectedRecordObjectInState, getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync, updateIsCanvasLoading, getAccountExpensePerDiemTypeAndRateAsyc, addAccountExpensePerDiemEntryAsync, UpdatedAccountExpensePerDiemEntryAsync } from '../expenseSlice';
import * as yup from 'yup';
import { Formik } from "formik";
import { expenseEntryInitialsForAdd } from "../interfaces/expenseClass";
import { DateRangePicker } from "rsuite";
import { format } from 'date-fns';
import { ShowSwal,ShowSwalForCanvas } from '../../../common/SweetAlert';
import 'rsuite/dist/rsuite.css';
import '../../../common/rsuite-datepicker.css';
import fetchAPI from "../../../common/fetchAPI";
import moment from "moment";
import { resetDefaultCategory } from "../../admin/expensePolicyPerDiem/expensePolicyPerDiemSlice";
import { load } from "@syncfusion/ej2-react-gantt";
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from "react-i18next";
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, FormatInvoiceDecimalNumber, formatDateWithDateAndMonthName } from '../../../common/timeLiveFunction';
import CanvasLoader from "../../../common/CanvasLoader";
// import '../../../common/rsuite-datepicker.css';
interface CheckboxStates {
    [date: string]: {
        [key: string]: boolean;
    };
}
interface Reimbursecheckbox {
    [date: string]: {
        [key: string]: boolean;
    };
}
interface DropdownItem {
    value: number;
    label: string;
}
interface PerDiemType {
    AccountExpensePolicyPerDiemTypeName: string;
    AccountExpensePolicyPerDiemTypeId: number;
}


interface ReimburseItem {
    AccountExpensePolicyPerDiemTypeId: number;
    Reimburse: number;
    AccountExpenseEntryDate: string;
}

const objDropdown = {
    perDiemLocation: [],
    projects: [],
    expenses: [],
    accountexpenseentry: []
}

const objPerDiemValues = {
    AccountExpensePolicyPerDiemLocationId: 0,
    AccountProjectId: 0,
    AccountExpenseId: 0,
}

type ExpandedDatesType = {
    [key: string]: boolean;
};

const ExpensePerdiem = (props: any) => {

    const { modelRef, expenseSheetObject, oncloseModal, onopenModal, showModal, handleClose, modelRefPerDiem } = props;
    const formikRef = useRef<any>(null);
     const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [tab, setTab] = useState('Per Diem');
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { obj } = location.state || {};
    const { t } = useTranslation();
    const params = new URLSearchParams(location.search);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expenseEntryInitialsForAdd);
    const [perDiemValues, setPerDiemValues] = useState<any | ''>(objPerDiemValues);
    const [perdiemResponse, setPerdiemResponse] = useState<any | ''>(objDropdown);
    const {sessionAccountId,maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, decimalPlaces} = useAppSelector(state => state.globalState);
    const { selectedRecord, isLoading, AccountExpenseEntryId, isEdit, MasterEmployeeExpenseSheetId, expensesheetDate, AccountEmployeeId, expenseSheetDescription, reimburseCurrencyId } = useAppSelector(state => state.expense);
    const ParamExpenseEntryId = AccountExpenseEntryId !== undefined && AccountExpenseEntryId > 0 ? AccountExpenseEntryId : 0;
    const [startDate, setStartDate] = useState(new Date());
    let AccountEmployeeExpenseSheetId = '';
    if (MasterEmployeeExpenseSheetId && MasterEmployeeExpenseSheetId !== '') {
        AccountEmployeeExpenseSheetId = MasterEmployeeExpenseSheetId;
    } else if (obj && obj.AccountEmployeeExpenseSheetId) {
        AccountEmployeeExpenseSheetId = obj.AccountEmployeeExpenseSheetId;
    }
    const [endDate, setEndDate] = useState(new Date());
    const [showDiv, setShowDiv] = useState(false);
    const [perDiemData, setPerDiemData] = useState(['']);
    const [perDiemType, setPerDiemType] = useState(['']);
    const [perDiemLocationRate, setPerDiemLocationRate] = useState(['']);
    const [perDiemLocations, setPerDiemLocations] = useState([]);
    const [expensePolicyPerDiemLocationId, setExpensePolicyPerDiemLocationId] = useState(0);
    const currentDate = new Date();
    const [checkboxStates, setCheckboxStates] = useState<CheckboxStates>({});
    const [reimbursecheckbox, setReimbursecheckbox] = useState<Reimbursecheckbox>({});
    const [reimburseArray, setReimburseArray] = useState<ReimburseItem[]>([]);
    const [isDateRangeEnabled, setIsDateRangeEnabled] = useState(true);
    const [isLocationEnabled, setIsLocationEnabled] = useState(true);
    const [expandedDates, setExpandedDates] = useState<ExpandedDatesType>({});
    const [IsDescription, setIsDescription] = useState('');
    const [ClientId, setClientId] = useState(0);
    const [isLoader, setIsLoader] = useState(true);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const [data, setData] = useState<DropdownItem[]>([{ value: 0, label: 'None' }]);

    const toggleExpand = (date: any) => {
        setExpandedDates((prev: any) => ({
            ...prev,
            [date]: !prev[date],
        }));
    };


    useEffect(() => {

        if (AccountExpenseEntryId > 0){
        if (perdiemResponse.accountexpenseentry.length > 0) {
            setShowDiv(true);
            setIsDateRangeEnabled(false);
            setIsLocationEnabled(false);
            const date = new Date(moment(perdiemResponse.accountexpenseentry[0].AccountExpenseEntryDate).format(dateInsertionFormat));
            setStartDate(date);
            setEndDate(date);

                const _dtPerDiemType: any = [{
                    AccountExpensePolicyPerDiemTypeId: perdiemResponse.accountexpenseentry[0].AccountExpensePolicyPerDiemTypeId,
                    AccountExpensePolicyPerDiemTypeName: perdiemResponse.accountexpenseentry[0].AccountExpensePolicyPerDiemTypeName
                }];
                setPerDiemType([_dtPerDiemType][0]);

                const newPerDiemData: any = [{
                    Amount: perdiemResponse.accountexpenseentry[0].Amount,
                    ExpenseEntryDate: perdiemResponse.accountexpenseentry[0].AccountExpenseEntryDate,
                    [perdiemResponse.accountexpenseentry[0].AccountExpensePolicyPerDiemTypeName]: perdiemResponse.accountexpenseentry[0].Amount,
                    Reimburse: perdiemResponse.accountexpenseentry[0].Reimburse === 'Yes' ? 1 : 0,
                    AccountCurrencyId: perdiemResponse.accountexpenseentry[0].AccountCurrencyId,
                    CurrencyCode: perdiemResponse.accountexpenseentry[0].CurrencyCode
                }];

                setPerDiemData(newPerDiemData);
                const objPerDiemLocationRate: any = [{
                    AccountExpensePolicyPerDiemTypeId: perdiemResponse.accountexpenseentry[0].AccountExpensePolicyPerDiemTypeId,
                    CurrencyCode: perdiemResponse.accountexpenseentry[0].CurrencyCode,
                    PerDiemRate: perdiemResponse.accountexpenseentry[0].Amount,
                    SystemCurrencyId: perdiemResponse.accountexpenseentry[0].AccountCurrencyId
                }];
                setPerDiemLocationRate([objPerDiemLocationRate]);
                renderPerDiemRecord(newPerDiemData, _dtPerDiemType, objPerDiemLocationRate);

                const updatedReimburseCheckbox = newPerDiemData.reduce((acc: any, item: any) => {
                    const date = moment(item.ExpenseEntryDate).format("DD-MMM-YYYY");
                    if (!acc[date]) acc[date] = {};
                    for (let key in item) {
                        if (key !== "ExpenseEntryDate" && key !== "Amount" && key !== "Reimburse" && key !== "AccountCurrencyId" && key !== "CurrencyCode") {
                            acc[date][key] = item.Reimburse !== 1;
                        }
                    }
                    return acc;
                }, {});
                setReimbursecheckbox(updatedReimburseCheckbox);
            }
        } else {
            setShowDiv(false);
            setIsDateRangeEnabled(true);
            setIsLocationEnabled(true);
            const date = new Date();
            setStartDate(date);
            setEndDate(date);
            setPerDiemData(['']);
            setPerDiemLocationRate(['']);
            setPerDiemType(['']);
            renderPerDiemRecord([], [], []);
        }

    }, [AccountExpenseEntryId, perdiemResponse.accountexpenseentry]);



    useEffect(() => {
        renderPerDiemDropdownFields();
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        } 
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    }, [selectedRecord, AccountExpenseEntryId]);

    const renderPerDiemDropdownFields = async () => {
        setIsLoader(true);
        const response = await fetchAPI('api/V2/ExpensePolicies/GetAllDataInSingleRequest/' + sessionAccountId + '/' + AccountEmployeeId + '/' + AccountExpenseEntryId, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        setPerDiemLocations(json.Data["PerDiemLocation"])
        json.Data["PerDiemLocation"].map((item: any) => {
            item.value = item.AccountExpensePolicyPerDiemLocationId;
            item.label = item.PerDiemLocationName;
            delete item.AccountExpensePolicyPerDiemLocationId;
            delete item.PerDiemLocationName;
        });
        json.Data["PerDiemLocation"].unshift({ value: '', label: 'None' });

        json.Data["AccountProject"].map((item: any) => {
            item.value = item.AccountProjectId;
            item.label = item.ProjectName;
            delete item.AccountProjectId;
            delete item.ProjectName;
        });
        json.Data["AccountProject"].unshift({ value: '', label: 'None' });

        json.Data["AccountExpense"].map((item: any) => {
            item.value = item.AccountExpenseId;
            item.label = item.AccountExpenseName;
            delete item.AccountExpenseId;
            delete item.AccountExpenseName;
        });
        json.Data["AccountExpense"].unshift({ value: '', label: 'None' });

        setPerdiemResponse({
            ...perdiemResponse,
            perDiemLocation: json.Data["PerDiemLocation"],
            projects: json.Data["AccountProject"],
            expenses: json.Data["AccountExpense"],
            accountexpenseentry: json.Data["AccountExpenseEntry"]
        })


        if (json && json.Data && json.Data["AccountExpenseEntry"] && json.Data["AccountExpenseEntry"][0]) {
            setPerDiemValues({
                ...perDiemValues,
                AccountExpensePolicyPerDiemLocationId: AccountExpenseEntryId !== 0 ? json.Data["AccountExpenseEntry"][0].AccountExpensePolicyPerDiemLocationId : 0,
                AccountProjectId: AccountExpenseEntryId !== 0 ? json.Data["AccountExpenseEntry"][0].AccountProjectId : 0,
                AccountExpenseId: AccountExpenseEntryId !== 0 ? json.Data["AccountExpenseEntry"][0].AccountExpenseId : 0,
            });

            if (AccountExpenseEntryId != 0) {
                setIsDescription(json.Data["AccountExpenseEntry"][0].Description);
                setClientId(json.Data["AccountExpenseEntry"][0].AccountClientId);
            } else {
                setIsDescription('');
            }
            setIsLoader(false);

        } else {
            setPerDiemValues({
                ...perDiemValues,
                AccountExpensePolicyPerDiemLocationId: 0,
                AccountProjectId: 0,
                AccountExpenseId: 0,
            });
            setIsLoader(false);
            setIsDescription('');
        }

    }


    const handleSubmit = () => {


        let finalArray: any = [];
        perDiemData.forEach((item: any) => {
            for (let key in item) {
                let itemObject = {
                    AccountExpenseEntryDate: '',
                    AccountId: sessionAccountId,
                    AccountEmployeeId: AccountEmployeeId,
                    AccountClientId: ClientId,
                    AccountProjectId: perDiemValues?.AccountProjectId,
                    AccountExpenseId: perDiemValues?.AccountExpenseId,
                    Description: IsDescription,
                    Amount: 0,
                    TeamLeadApproved: 0,
                    ProjectManagerApproved: 0,
                    AdministratorApproved: 0,
                    Approved: 0,
                    IsBillable: 0,
                    Rejected: 0,
                    Quantity: 0,
                    Rate: 0,
                    AmountBeforeTax: 0,
                    TaxAmount: 0,
                    Reimburse: 1,
                    AccountCurrencyId: 0,
                    AccountBaseCurrencyId: 0,
                    ExchangeRate: 0,
                    Submitted: 0,
                    Billed: 0,
                    AccountExpensePolicyPerDiemTypeId: 0,
                    AccountExpensePolicyPerDiemLocationId: perDiemValues?.AccountExpensePolicyPerDiemLocationId,
                    TotalAmount: 0
                };
                if (key !== "ExpenseEntryDate" && key !== "Amount" && key !== "Reimburse" && key !== "AccountCurrencyId" && key !== "CurrencyCode") {
                    let keyItem = (perDiemType.find((obj: any) => obj.AccountExpensePolicyPerDiemTypeName === key) as any)?.AccountExpensePolicyPerDiemTypeId;

                    if (itemObject.AccountExpensePolicyPerDiemTypeId === 0) {
                        itemObject.AccountExpenseEntryDate = item.ExpenseEntryDate;
                        itemObject.AccountExpensePolicyPerDiemTypeId = keyItem;
                        itemObject.Amount = item[key];
                        itemObject.TotalAmount = item.Amount;
                        let getUpdateReimburse = reimburseArray.find((reimburse: any) =>
                        (AccountExpenseEntryId === 0 ? (
                            reimburse.AccountExpensePolicyPerDiemTypeId === keyItem && reimburse.AccountExpenseEntryDate === itemObject.AccountExpenseEntryDate) : (
                            reimburse.AccountExpensePolicyPerDiemTypeId === keyItem
                        ))) ?? undefined;

                        itemObject.Reimburse = getUpdateReimburse !== undefined ? getUpdateReimburse.Reimburse : item.Reimburse;
                        if (perdiemResponse.accountexpenseentry.length > 0) {
                            itemObject.AccountCurrencyId = (perDiemLocationRate.find((obj: any) => obj.AccountExpensePolicyPerDiemTypeId === keyItem) as any)?.SystemCurrencyId ?? item.AccountCurrencyId;
                        } else {
                            itemObject.AccountCurrencyId = isEdit === 0 ? (perDiemLocationRate.find((obj: any) => obj.AccountExpensePolicyPerDiemTypeId === keyItem) as any)?.SystemCurrencyId : item.AccountCurrencyId;
                        }
                        finalArray.push(itemObject);
                    } else {
                        itemObject.AccountExpensePolicyPerDiemTypeId = keyItem;
                        itemObject.Amount = item[key];
                        finalArray.push(itemObject);
                    }
                }
            }
        });
        finalArray = finalArray.filter((obj: any) => obj.Amount !== 0);

        AddAndUpdateAccountExpensePerDiem(finalArray);
        if (modelRefPerDiem.current) {
            modelRefPerDiem.current.click();
        }
       
    };


    const AddAndUpdateAccountExpensePerDiem = (value: any) => {
        let accountEmployeeExpenseSheetId = AccountEmployeeExpenseSheetId;
        if (AccountExpenseEntryId > 0) {
            dispatch(UpdatedAccountExpensePerDiemEntryAsync({ AccountExpenseEntryId: AccountExpenseEntryId, expenseRecords: value, expenseSheetDate: moment(expensesheetDate).format("DD-MMM-YYYY") }))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast('Per Diem Successfully Update', 'Success', "success", "toast-top-right");
                    dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId));

                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {

            dispatch(addAccountExpensePerDiemEntryAsync({
                accountEmployeeId: AccountEmployeeId,
                accountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId === '' ? '00000000-0000-0000-0000-000000000000' : AccountEmployeeExpenseSheetId,
                reimbursementCurrencyId: reimburseCurrencyId,
                sheetDescription: expenseSheetDescription,
                expenseSheetDate: expensesheetDate,
                perdiemarray: value
            }))
                .unwrap()
                .then((result) => {
                    let id = result.Data[0].AccountEmployeeExpenseSheetId;
                    dispatch(updateMasterExpenseSheetId(id));
                    ShowToast('Perdiem Entry Successfully Inserted', 'Success', "success", "toast-top-right");
                    dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(id));
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }

    }

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    const handleDateRangeChange = (value: any) => {
        const newStartDate = moment(value[0]).format("DD-MMM-YYYY");
        const newEndDate = moment(value[1]).format("DD-MMM-YYYY");
        if (newEndDate < newStartDate) {
            ShowToast('Travel StartDate "' + newStartDate + '" cannot be greater than EndDate "' + newEndDate + '" ', 'warning', "warning", "toast-top-right");
            return;
        }
        setReimburseArray([]);
        // setStartDate(value[0]);
        // setEndDate(value[1]);
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        setStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        setEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        const FirstDate = value[0];
        const SecondDate = value[1];
        PopulateExpenseEntryPerDiemRecords(expensePolicyPerDiemLocationId, AccountEmployeeId, moment(FirstDate).format(dateInsertionFormat), moment(SecondDate).format(dateInsertionFormat));
    };

    const PopulateExpenseEntryPerDiemRecords = (AccountExpensePolicyPerDiemLocationId: any, AccountEmployeeId: any, StartDate: any, EndDate: any) => {

        dispatch(getAccountExpensePerDiemTypeAndRateAsyc({ AccountEmployeeId, AccountExpensePolicyPerDiemLocationId, StartDate, EndDate }))
            .unwrap()
            .then((originalPromiseResult) => {
                const perDiemType = originalPromiseResult.Data["dtPerDiemType"];
                const _dtPerDiemRate = originalPromiseResult.Data["dtPerDiemRate"];
                const perDiemLocationRate = originalPromiseResult.Data["PerDiemLocationRate"];
                let perDiemData = [];
                if (_dtPerDiemRate && _dtPerDiemRate.length > 0) {
                    const jsonData = JSON.parse(_dtPerDiemRate[0][Object.keys(_dtPerDiemRate[0])[0]]);
                    perDiemData = jsonData !== null ? jsonData : [];
                }
                if (perDiemData.length > 0) {
                    for (let item of perDiemData) {
                        item.Reimburse = 1;
                    }
                }
                setPerDiemLocationRate(perDiemLocationRate);
                setPerDiemType(perDiemType);
                setPerDiemData(perDiemData);
                renderPerDiemRecord(perDiemData, perDiemType, perDiemLocationRate);
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    };

    const onChange = (data: any, filterName: any) => {

        setReimburseArray([]);
        setPerDiemValues({
            ...perDiemValues,
            AccountExpensePolicyPerDiemLocationId: filterName.name == "perdiemlocationlist" ? perdiemResponse.perDiemLocation.filter((x: any) => x.value == data.value)[0].value : perDiemValues.AccountExpensePolicyPerDiemLocationId,
            AccountProjectId: filterName.name == "projectlist" ? perdiemResponse.projects.filter((x: any) => x.value == data.value)[0].value : perDiemValues.AccountProjectId,
            AccountExpenseId: filterName.name == "expenselist" ? perdiemResponse.expenses.filter((x: any) => x.value == data.value)[0].value : perDiemValues.AccountExpenseId
        });

        if (filterName.name === 'perdiemlocationlist' && data.value !== null) {
            setExpensePolicyPerDiemLocationId(data.value);
            // PopulateExpenseEntryPerDiemRecords(data.value, AccountEmployeeId, moment(startDate).format("MM-DD-YYYY"), moment(endDate).format("MM-DD-YYYY"));
            PopulateExpenseEntryPerDiemRecords(data.value, AccountEmployeeId, moment(startDate).format(dateInsertionFormat), moment(endDate).format(dateInsertionFormat));
            setShowDiv(true);
        };

    };


    const renderPerDiemRecord = (perDiemData: any, perDiemType: any, perDiemLocationRate: any) => {    
        const headers = [
            // t(`Per Diem Type Name`),
            // t(`Apply Based On Travel`),
            // t(`Reimburse`),
            // t(`Amount`)
            getValueFromResource('Per Diem Type Name', dispatch,t),
            getValueFromResource('Apply Based On Travel', dispatch,t),
            getValueFromResource('Reimburse', dispatch,t),
            getValueFromResource('Amount', dispatch,t)
        ];

        const rows = [];
        perDiemData.forEach((data: any, index: any) => {
          //  const date = moment(data.ExpenseEntryDate).format("DD-MMM-YYYY");
          const date = formatDateWithDateAndMonthName(data.ExpenseEntryDate, cultureInfoName.toString());
            rows.push(
                <tr key={`dateEntry_${index}`} style={{ marginLeft: '15px' }}>

                    <td colSpan={headers.length} style={{ padding: '5px', backgroundColor: '#efeff1', borderRight: '1px solid #efeff1' }}>
                        <button type="button" onClick={() => toggleExpand(date)}>
                            {expandedDates[date] ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}
                        </button>
                        <b>{date}</b>
                    </td>
                </tr>
            );

            if (expandedDates[date]) {
                let trHTML = [];
                let isEntryDeleted = '';

                for (let key in data) {

                    if (key !== "ExpenseEntryDate" && key !== "Amount" && key !== "Reimburse" && key !== "AccountCurrencyId" && key !== "CurrencyCode") {
                       if (perdiemResponse.accountexpenseentry.length > 0) {
                            const perDiemTypeId = perDiemType.find((obj: any) => obj.AccountExpensePolicyPerDiemTypeName === key)?.AccountExpensePolicyPerDiemTypeId;                          
                            if (perDiemLocationRate.length === 0) {
                                isEntryDeleted = " (Deleted)";                              
                              
                            } else {
                                const locationExists = perDiemLocationRate.filter(
                                    (x: any) => Number(x.AccountExpensePolicyPerDiemTypeId) === Number(perDiemTypeId)
                                );
                                isEntryDeleted = locationExists ? '' : " (Deleted)";
                            }
                        }

                        trHTML.push(
                            <tr key={`${date}_${index}_${key}`} className={index}>
                                <td style={{ width: '350px', paddingTop: '11px', fontSize: '12px', paddingLeft: '8px' }}>{key}{isEntryDeleted}</td>
                                <td style={{ width: '320px', textAlign: 'center' }}>
                                    <td className='text-center'>
                                        {/* <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            checked={!checkboxStates[date]?.[key]}
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            disabled={perdiemResponse.accountexpenseentry.length > 0}
                                            value={`${perDiemType.find((obj: any) => obj.AccountExpensePolicyPerDiemTypeName === key)?.AccountExpensePolicyPerDiemTypeId};${data[key]}`}
                                            onChange={(e) => handleCheckboxChange(data, date, key, !e.target.checked)}
                                        />
                                        <span style={{ marginLeft: '2px' }}></span>
                                    </div> */}
                                    </td>
                                    <span className="form-check form-switch form-check-custom">
                                        <label style={{ marginLeft: '10%' }}>
                                            <input
                                                type="checkbox"
                                                checked={!checkboxStates[date]?.[key]}
                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                disabled={perdiemResponse.accountexpenseentry.length > 0}
                                                value={`${perDiemType.find((obj: any) => obj.AccountExpensePolicyPerDiemTypeName === key)?.AccountExpensePolicyPerDiemTypeId};${data[key]}`}
                                                onChange={(e) => handleCheckboxChange(data, date, key, !e.target.checked)}
                                            />
                                            <span style={{ marginLeft: '2px' }}></span>
                                        </label>
                                    </span>
                                </td>
                                <td style={{ width: '320px' }}>
                                    <span className="form-check form-switch form-check-custom">
                                        <label style={{ marginLeft: '10%' }}>
                                            <input
                                                type="checkbox"
                                                checked={!reimbursecheckbox[date]?.[key]}
                                                onChange={(e) => handleCheckboxReimburse(data, date, key, !e.target.checked)}
                                                className="form-check-input custom-padding-right h-15px w-30px"
                                            />
                                            <span style={{ marginLeft: '2px' }}></span>
                                        </label>
                                    </span>
                                </td>

                                <td style={{ width: '350px', paddingTop: '12px' }}>
                                    <span style={{ fontSize: '12px', fontWeight: '600' }}>
                                        {data.CurrencyCode ? data.CurrencyCode
                                            :
                                            !checkboxStates[date]?.[key] ?
                                                perDiemLocationRate
                                                    .filter((obj: any) => obj.AccountExpensePolicyPerDiemTypeId === (perDiemType.filter((obj: any) => obj.AccountExpensePolicyPerDiemTypeName === key)[0].AccountExpensePolicyPerDiemTypeId))
                                                [0].CurrencyCode : 0
                                        }
                                    </span> {' '}{!checkboxStates[date]?.[key] || data[key] === 0 ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), data[key], decimalPlaces) : ''}
                                </td>                               
                            </tr>
                        );
                    }
                }
                rows.push(trHTML);
            }

        });

        // Add the headers row
        rows.unshift(
            <tr key="headers" className="text-muted align-middle" style={{ verticalAlign: '0.2em' }}>
                {headers.map((header, index) => (
                    <td key={index} style={{ border: '1px solid #efeff1', height: '35px', paddingLeft: '10px' }}>{header}</td>
                ))}
            </tr>
        );

        return <>{rows}</>;
    }

    const handleCheckboxChange = (data: any, date: any, key: string, checked: boolean) => {
        setCheckboxStates(prevState => ({
            ...prevState,
            [date]: {
                ...prevState[date],
                [key]: checked
            }
        }));
    };

    const handleCheckboxReimburse = (data: any, date: any, typeName: string, checked: boolean) => {
        setReimbursecheckbox(prevState => ({
            ...prevState,
            [date]: {
                ...prevState[date],
                [typeName]: checked
            }
        }));

        const isCheckedReimburse = checked ? 0 : 1;
        const getDate = moment(data.ExpenseEntryDate).format("DD-MMM-YYYY");
        const obj: any = perDiemData.find((perDiem: any) => moment(perDiem.ExpenseEntryDate).format("DD-MMM-YYYY") === getDate);

        let reimburseObject: any;
        for (var key in obj) {
            reimburseObject = {
                AccountExpensePolicyPerDiemTypeId: 0,
                Reimburse: 1,
                AccountExpenseEntryDate: ''
            }
            let perDiemTypeName = typeName;
            if (key === (perDiemTypeName.includes(" (Deleted)") ? perDiemTypeName.split(" (Deleted)")[0] : perDiemTypeName)) {
                const filteredPerDiemTypes: any = perDiemType.filter((perDiemType: any) => perDiemType.AccountExpensePolicyPerDiemTypeName === key);
                if (filteredPerDiemTypes.length > 0) {
                    reimburseObject.AccountExpensePolicyPerDiemTypeId = filteredPerDiemTypes[0]?.AccountExpensePolicyPerDiemTypeId;
                } else {
                    console.error("No matching per diem type found for key:", key);
                }
                reimburseObject.Reimburse = isCheckedReimburse;
                reimburseObject.AccountExpenseEntryDate = obj.ExpenseEntryDate;
                const existingIndex = reimburseArray.findIndex((reimburseArray: any) => reimburseArray.AccountExpensePolicyPerDiemTypeId === reimburseObject.AccountExpensePolicyPerDiemTypeId && reimburseArray.AccountExpenseEntryDate === reimburseObject.AccountExpenseEntryDate);
                if (existingIndex !== -1) {
                    const updatedArray = [...reimburseArray];
                    updatedArray[existingIndex].Reimburse = isCheckedReimburse;
                    setReimburseArray(updatedArray);
                } else {
                    setReimburseArray([...reimburseArray, reimburseObject]);
                }
            }
        }
    };

    useEffect(() => {

    }, [reimburseArray]);


    const handleCombinedChange = (selectedProject: any, filter: any) => {
        const AccountClient = perdiemResponse.projects.find((x: any) => x.value === selectedProject?.value);
        setClientId(AccountClient.AccountClientId);
        onChange(selectedProject, filter);
    };

    return (
        <>

            <Formik
                innerRef={formikRef}
                initialValues={{
                 ...currentFieldsData,
                    AccountExpensePolicyPerDiemLocationId: perDiemValues?.AccountExpensePolicyPerDiemLocationId || '',
                    AccountProjectId: perDiemValues?.AccountProjectId || '',
                    AccountExpenseId: perDiemValues?.AccountExpenseId || '',
                }}
                enableReinitialize={true}
                onSubmit={(action) => { handleSubmit(); action.resetForm() }}
                validationSchema={yup.object().shape({
                    AccountExpensePolicyPerDiemLocationId: yup
                        .string()
                        .required (getValueFromResource('Travel Location field is Required', dispatch, t)),
                    AccountProjectId: yup
                        .string()
                        .required (getValueFromResource('Project field is Required', dispatch, t)),
                    AccountExpenseId: yup
                        .string()
                        .required (getValueFromResource('Expense field is Required', dispatch, t))
                })}
            >
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue }) => (
                    <Fragment>
                        <form onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSubmit();
                            }
                        }}>
                            <div className="modal fade drawer-overlay" data-bs-backdrop="false" tabIndex={-1} id="perDiemModal" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                                <div className="modal-dialog modal-xl" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h6 className="modal-title">{Object.keys(selectedRecord).length > 0 ? getValueFromResource('Update ', dispatch,t) : getValueFromResource('Add ', dispatch, t)} {getValueFromResource('Per Diem', dispatch,t)} </h6>
                                            <div
                                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <KTSVG
                                                    path="/media/icons/duotune/arrows/arr061.svg"
                                                    className="svg-icon svg-icon-2x"
                                                />
                                            </div>
                                        </div>
                                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                            {isLoader ? <CanvasLoader /> : <>
                                                {/* <div className='tableContainer'>
                                                <div className="modal-body" style={{ flexGrow: 1, overflowY: 'auto', padding: '1rem' }}> */}
                                                    <div className='row spacingBetweenRows' >
                                                        <div className="col-md-6">
                                                            <label className="form-label fs-7 fw-normal mb-2">
                                                                {/* {t('Travel Start & End Date')} */}
                                                                {getValueFromResource('Travel Start & End Date',dispatch, t)}
                                                                </label>
                                                            <DateRangePicker
                                                                onChange={handleDateRangeChange}
                                                                value={[startDate, endDate]}
                                                                // placeholder='Please Select Date Range'
                                                                placeholder={displayedRange}
                                                                cleanable={false}
                                                                character={' - '}
                                                                placement="bottomEnd"
                                                                // disabled={!isDateRangeEnabled}
                                                                className={isDateRangeEnabled ? '' : 'disabled-datepicker'}
                                                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                                                            >
                                                            </DateRangePicker>                                                       
                                                        </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t(`Travel Location`)} */}
                                                            {getValueFromResource('Travel Location',dispatch, t)}
                                                            </label>

                                                        <Select
                                                            value={
                                                                perdiemResponse.accountexpenseentry.length > 0
                                                                    ? perdiemResponse.accountexpenseentry.map((item: any) => ({ value: item.AccountExpensePolicyPerDiemLocationId, label: item.PerDiemLocationName }))
                                                                    : perdiemResponse.perDiemLocation.find((x: any) => x.value === perDiemValues.AccountExpensePolicyPerDiemLocationId)
                                                            }
                                                            className="basic-single fs-7 fw-normal"
                                                            classNamePrefix="select"
                                                            name="perdiemlocationlist"
                                                            onBlur={() => setFieldTouched('AccountExpensePolicyPerDiemLocationId')}
                                                            onChange={(e, name) => onChange(e, name)}
                                                            options={perdiemResponse.perDiemLocation}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            isDisabled={!isLocationEnabled}
                                                        />
                                                        <div style={{ paddingRight: 20 }}>
                                                            {touched.AccountExpensePolicyPerDiemLocationId && errors.AccountExpensePolicyPerDiemLocationId &&
                                                                <p className='errorMsg'>{errors.AccountExpensePolicyPerDiemLocationId as string}</p>
                                                            }
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className='row spacingBetweenRows' >
                                                    <div className="col-md-6">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t(`Project`)} */}
                                                            {getValueFromResource('Project',dispatch, t)}
                                                            </label>
                                                        <Select
                                                            value={perdiemResponse.projects.filter((x: any) => x.value == perDiemValues.AccountProjectId)}
                                                            className="basic-single fs-7 fw-normal"
                                                            classNamePrefix="select"
                                                            name="projectlist"
                                                            onBlur={() => setFieldTouched('AccountProjectId')}
                                                            onChange={(e, name) => handleCombinedChange(e, name)}
                                                            options={perdiemResponse.projects}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                        />
                                                        <div style={{ paddingRight: 20 }}>
                                                            {touched.AccountProjectId && errors.AccountProjectId &&
                                                                <p className='errorMsg'>{errors.AccountProjectId as string}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t(`Expense`)} */}
                                                            {getValueFromResource('Expense',dispatch, t)}
                                                            </label>
                                                        <Select
                                                            value={perdiemResponse.expenses.filter((x: any) => x.value == perDiemValues.AccountExpenseId)}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            name="expenselist"
                                                            onBlur={() => setFieldTouched('AccountExpenseId')}
                                                            onChange={(e, name) => onChange(e, name)}
                                                            options={perdiemResponse.expenses}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                        />
                                                        <div style={{ paddingRight: 20 }}>
                                                            {touched.AccountExpenseId && errors.AccountExpenseId &&
                                                                <p className='errorMsg'>{errors.AccountExpenseId as string}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div className='row' style={{ marginTop: '15px', width: '100%' }}>
                                                        <div className="col-md-12">
                                                            <label className="form-label">
                                                                {/* {t(`Description`)} */}
                                                                {getValueFromResource('Description',dispatch, t)}
                                                                </label>
                                                            <textarea className="form-control fs-7 fw-normal"
                                                                id='Description'
                                                                name='Description'
                                                                value={IsDescription}
                                                                onChange={e => setIsDescription(e.target.value)}
                                                                rows={7}>
                                                            </textarea>
                                                        </div>
                                                    </div>
                                                    {showDiv && (
                                                        <div className='row spacingBetweenRows col-md-12'>
                                                            <h6 className="modal-title" style={{ marginBottom: '10px' }}>
                                                                {/* {t('Expense Per Diem List')}  */}
                                                                {getValueFromResource('Expense Per Diem List',dispatch, t)}
                                                                </h6>
                                                            <div id="expenseParentDatatableDiv" className="portlet-body table-both-scroll ld-over" style={{ paddingBottom: '10px' }}>
                                                                <table id="tbl_PerDiemRecord" className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                                                                    <tbody>
                                                                        {renderPerDiemRecord(perDiemData, perDiemType, perDiemLocationRate)}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* </div>
                                            </div> */}
                                                </>}
                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                                    data-bs-dismiss='modal'
                                                >
                                                    {/* {t('Cancel')} */}
                                                    {getValueFromResource('Cancel',dispatch, t)}
                                                </button>
                                                <button type="button"
                                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm "
                                                    data-bs-dismiss='modal' onClick={() => handleSubmit()} disabled={!isValid}>
                                                    {Object.keys(selectedRecord).length > 0 ?  getValueFromResource('Update ', dispatch,t) : getValueFromResource('Add ', dispatch, t)} {getValueFromResource('Per Diem', dispatch,t)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </form>
                    </Fragment>
                )}
            </Formik>

        </>

    )


}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default ExpensePerdiem;